import { ApiParticipant, MaCheckinResult } from '../../contexts/HttpClientContext';

export enum EventModalNavigationState {
    eventInfo,
    participantList,
    scanner
}

export interface ApiCheckInResponse {
    checkInStatus: "notBooked" | "alreadyCheckedIn" | "success" | "removed";
    booking?: ApiCheckInParticipant;
}

export interface ApiCheckInParticipant {
    id: number;
    eventId: string;
    userKey: string;
    name: string;
    bookingInfo: string;
    partnerName: string;
    partnerBookingInfo: string;
    visibleForOthers: string;
    membershipNumber: string;
    booked: string;
    partnerBooked: string;
    partnerMembershipNumber: string;
    checkedIn: string;
    checkedInBy: string;
}

export interface CheckInState {
    status: "idle"
    | "loading"
    | "success"
    | "removed"
    | "alreadyCheckedIn"
    | "error-checkIn"
    | "error-checkOut"
    | "success-ask-partner"
    | "partner-checkIn-loading"
    | "partner-success"
    | "partner-alreadyCheckedIn"
    | "partner-error";
    partnerParticipant?: ApiParticipant | null;
    maResult?: MaCheckinResult;
}

export interface ScannerCheckInState {
    status: "idle"
    | "loading"
    | "success"
    | "alreadyCheckedIn"
    | "removed"
    | "error"
    | "notBooked"
    | "invalidFormat"
    | "success-ask-partner"
    | "partner-checkIn-loading"
    | "partner-success"
    | "partner-alreadyCheckedIn"
    | "partner-error";

    booking?: ApiCheckInParticipant
    partnerParticipant?: ApiParticipant | null;
    maResult?: MaCheckinResult;
}

export interface MaUserLookupResult {
    membershipNumber?: string;
    name?: string;
    firstName?: string;
    lastName?: string;
    isMember?: boolean | number | string;
    member?: boolean | number | string;
    membershipActive?: boolean | number | string;
    activeMember?: boolean | number | string;
    isActiveMember?: boolean | number | string;
    memberStatus?: boolean | number | string;
    addresses?: Array<{
        streetAddress?: string;
        city?: string;
    }>;
}
